// extracted by mini-css-extract-plugin
module.exports = {"dropzone":"Uploader_dropzone__1rP_y","active":"Uploader_active__6gKWc"};